//© 2025 Kaitlyn Troxell
import React, { useState } from "react";

function DurationModal({ 
  task, 
  startDate, 
  endDate,
  assignedContractor,
  onConfirm, 
  onCancel,
  isUpdate = false
}) {
  const [selectedEndDate, setSelectedEndDate] = useState(
    endDate ? (() => {
      const date = endDate instanceof Date ? new Date(endDate) : new Date(endDate);
      date.setDate(date.getDate() - 1); // Subtract 1 day for display (since FullCalendar adds 1)
      return date.toISOString().split('T')[0];
    })() : startDate.toISOString().split('T')[0]
  );

  const handleConfirm = () => {
    onConfirm(new Date(selectedEndDate)); // Pass new end date back to parent
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-container">
        <h3 className="modal-title">{isUpdate ? 'Change Task Duration' : 'Set Task Duration'}</h3>
        
        <div className="modal-section">
          <p className="modal-subtitle">
            <strong>Task:</strong> {task.title}
          </p>
          {assignedContractor && (
            <p className="modal-subtitle">
              <strong>Contractor:</strong> {assignedContractor.name}
            </p>
          )}
        </div>

        <div className="form-group">
          <label className="form-label" htmlFor="startDate">
            Start Date
          </label>
          <input
            type="date"
            id="startDate"
            value={startDate.toISOString().split('T')[0]}
            className="form-input"
            disabled
            style={{ backgroundColor: '#f0f0f0', cursor: 'not-allowed' }}
          />
        </div>

        <div className="form-group">
          <label className="form-label" htmlFor="endDate">
            End Date <span className="required">*</span>
          </label>
          <input
            type="date"
            id="endDate"
            value={selectedEndDate}
            onChange={(e) => setSelectedEndDate(e.target.value)}
            min={startDate.toISOString().split('T')[0]}
            className="form-input"
            required
          />
        </div>

        <div className="modal-actions">
          <button
            onClick={onCancel}
            className="modal-cancel-btn"
          >
            Cancel
          </button>
          
          <button
            onClick={handleConfirm}
            className="save-btn"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}

export default DurationModal;